export default {"src":"/_next/static/media/clock.0ae88f87.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};